import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/festivalaki.css";

export default function Festivalaki() {
	const navigate = useNavigate();
	const panelRef = useRef(null);
	const panelRef2 = useRef(null);
	const [active1, setactive1] = useState(0);
	const [active2, setactive2] = useState(0);

	useEffect(() => {
		const timeout = setTimeout(() => {
			const firstA = document.querySelector(".bio-thumb.panel1");
			if (firstA && !firstA.complete) {
				firstA.src = firstA.src.split("?")[0] + "?force=" + Date.now();
			}
			const firstB = document.querySelector(".bio-thumb.panel3");
			if (firstB && !firstB.complete) {
				firstB.src = firstB.src.split("?")[0] + "?force=" + Date.now();
			}
		}, 800);

		function setup(ref, setter) {
			const el = ref.current;
			if (!el) return () => {};
			const getPanelWidth = () => {
				const first = el.querySelector(".bio-panel");
				return first ? first.offsetWidth : el.clientWidth || 1;
			};
			function onScroll() {
				const panelWidth = getPanelWidth();
				const idx = Math.round(el.scrollLeft / panelWidth);
				setter(idx);
			}
			el.addEventListener("scroll", onScroll, { passive: true });
			window.addEventListener("resize", onScroll);
			onScroll();
			return () => {
				el.removeEventListener("scroll", onScroll);
				window.removeEventListener("resize", onScroll);
			};
		}
		const cleanA = setup(panelRef, setactive1);
		const cleanB = setup(panelRef2, setactive2);
		return () => {
			clearTimeout(timeout);
			cleanA && cleanA();
			cleanB && cleanB();
		};
	}, []);

	function handleImgError(e) {
		const img = e.currentTarget;
		// Simple one-time retry after a short delay (network hiccup mitigation)
		if (!img.dataset.retried) {
			img.dataset.retried = "true";
			setTimeout(() => {
				img.src = img.src.split("?")[0] + "?retry=" + Date.now();
			}, 200);
		} else {
			img.classList.add("img-error");
		}
	}

	function scrollToIndex(ref, i) {
		const el = ref.current;
		if (!el) return;
		const panels = el.querySelectorAll(".bio-panel");
		if (!panels[i]) return;
		panels[i].scrollIntoView({ behavior: "smooth", inline: "center" });
	}

	return (
		<div className="page-container festivalaki-bios">
			<img src="/festivalatsi.png" className="festivalaki-hero" />
			<h3 className="event-dates-heading">4 - 6 December 2026</h3>
			<h2 className="section-heading-lg">TEACHER INFO</h2>
			<div className="bio-group">
				{/* <h3 className="bio-heading" id="bio-heading">
					Alex & Maria
				</h3> */}
				<div
					ref={panelRef}
					className="bio-panels"
					role="region"
					aria-labelledby="bio-heading"
				>
					<div className="bio-panel">
						<section>
							<img
								src="/teachers/1.png"
								alt="panel1"
								className="bio-thumb panel1"
								loading="eager"
								decoding="async"
								fetchPriority="high"
								onError={handleImgError}
							/>
						</section>
					</div>
					<div className="bio-panel">
						<section>
							<img
								src="/teachers/2_2.png"
								alt="panel2"
								className="bio-thumb panel2"
								loading="lazy"
								decoding="async"
								onError={handleImgError}
							/>
						</section>
					</div>
				</div>
				<div className="bio-pagination" role="tablist" aria-label="Teachers photos row 1 pagination">
					<button
						className={"bio-dot" + (active1 === 0 ? " active" : "")}
						aria-label="Show first photo"
						aria-pressed={active1 === 0}
						onClick={() => scrollToIndex(panelRef, 0)}
					/>
					<button
						className={"bio-dot" + (active1 === 1 ? " active" : "")}
						aria-label="Show second photo"
						aria-pressed={active1 === 1}
						onClick={() => scrollToIndex(panelRef, 1)}
					/>
				</div>
			</div>

			<div className="bio-group bio-group-second">
				<div
					ref={panelRef2}
					className="bio-panels"
					role="region"
					aria-labelledby="bio-heading-second"
				>
					<div className="bio-panel">
						<section>
							<img
								src="/teachers/3.png"
								alt="panel3"
								className="bio-thumb panel3"
								loading="lazy"
								decoding="async"
								onError={handleImgError}
							/>
						</section>
					</div>
					<div className="bio-panel">
						<section>
							<img
								src="/teachers/4.png"
								alt="panel4"
								className="bio-thumb panel4"
								loading="lazy"
								decoding="async"
								onError={handleImgError}
							/>
						</section>
					</div>
				</div>
				<div className="bio-pagination" role="tablist" aria-label="Teachers photos row 2 pagination">
					<button
						className={"bio-dot" + (active2 === 0 ? " active" : "")}
						aria-label="Show third photo"
						aria-pressed={active2 === 0}
						onClick={() => scrollToIndex(panelRef2, 0)}
					/>
					<button
						className={"bio-dot" + (active2 === 1 ? " active" : "")}
						aria-label="Show fourth photo"
						aria-pressed={active2 === 1}
						onClick={() => scrollToIndex(panelRef2, 1)}
					/>
				</div>
			</div>
			<div className="festivalaki-video-wrapper">
				<iframe
					title="Festivalaki Promo Video"
					className="festivalaki-video"
					width="560"
					height="315"
					referrerPolicy="origin"
					src={`https://www.youtube.com/embed/8gD6yXBZ-HU?si=ohmyumj-IiE-Y4eN?rel=0&modestbranding=1&playsinline=1&enablejsapi=1&origin=${encodeURIComponent(
						window.location.origin
					)}`}
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					allowFullScreen
				/>
			</div>
			<button
				onClick={() => navigate("/festivalaki/registration-26")}
				className="registration-button"
			>
				REGISTER HERE
			</button>
			<h2 className="section-heading-lg schedule-heading">SCHEDULE</h2>
			<fieldset className="form-section schedule-section" aria-labelledby="schedule-legend">
				<p className="section-description">
					This year, we offer 3 levels consisting of 1 Lindy Hop and 1 Authentic Jazz class each.
				</p>
			</fieldset>
			<div
				className="schedule-image-section"
			>
				<img
					src="/schedule/schedule.png"
					alt="Detailed Festivalaki class and party schedule"
					className="festivalaki-schedule-image"
					loading="lazy"
					decoding="async"
				/>
			</div>
			<h2 className="section-heading-lg locations-heading">LOCATIONS</h2>
			<div className="locations-row">
				<fieldset
					className="form-section locations-section"
					aria-labelledby="locations-classes-legend"
				>
					<legend id="locations-classes-legend">Classes</legend>
					<p className="section-description">
						They will take place at the Students’ Centre, located at the University of Crete’s
						Voutes campus.
					</p>
				</fieldset>
				<fieldset
					className="form-section locations-section"
					aria-labelledby="locations-parties-legend"
				>
					<legend id="locations-parties-legend">Parties</legend>
					<p className="section-description">
						Friday's warmup party will take place at the Students' Centre.
					</p>
					<p className="section-description parties-description">
						SATURDAY'S AND SUNDAY'S PARTY LOCATION TBD.
					</p>
				</fieldset>
			</div>
			<div className="festivalaki-map-wrapper" aria-label="Map showing Students' Centre location">
				<iframe
					title="Festivalaki Locations Map"
					className="festivalaki-map"
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
					allowFullScreen
					src="https://www.google.com/maps/d/embed?mid=1MdcI3WR7I2ym9tvNdZt2XaSZmkQkGp8&ehbc=2E312&noprof=1"
				/>
			</div>
			<button
				onClick={() => navigate("/festivalaki/registration-26")}
				className="registration-button bottom"
			>
				REGISTER HERE
			</button>
		</div>
	);
}
